export default function favorite() {

    var Cookies = require('js-cookie');

    $(document).ready(function () {
        initFavoriteButtons();
        initFavoriteCounter();
    });

    var initFavoriteButtons = function() {

        $('[data-favorite-vehicle]').each(
            function() {
                var vehicleId = $(this).attr('data-favorite-vehicle');

                if( vehicleId != '' && $(this).attr('data-favorite-initialized') == undefined) {
                    $(this).on('click', function () {
                        toggleVehicleFavorite(vehicleId);
                        refreshVehicleButtonState($(this));
                    });

                    refreshVehicleButtonState($(this));

                    $(this).attr('data-favorite-initialized', true);
                }
            }
        );

        $('[data-favoris-remove-vehicle]').each(
            function() {
                var vehicleId = $(this).attr('data-favoris-remove-vehicle');

                if( vehicleId != '') {
                    $(this).on('click', function () {
                        toggleVehicleFavorite(vehicleId);
                        refreshVehicleButtonState($(this));

                        location.reload();
                    });
                }
            }
        );
    }

    var initFavoriteCounter = function() {
        $( document ).on( "favorite-list-updated", function() {
            refreshCounter();
        });

        refreshCounter();
    }

    var refreshCounter = function() {
        var favoriteVehicles = getFavoriteVehicleList();

        $('[data-favorite-counter]').text(favoriteVehicles.length);
    }

    var toggleVehicleFavorite = function(vehicleId) {
        var favoriteVehicles = getFavoriteVehicleList();

        if (favoriteVehicles.indexOf(vehicleId) === -1) {
            favoriteVehicles.push(vehicleId);
        } else {
            var indexVehicle = favoriteVehicles.indexOf(vehicleId);

            if (indexVehicle !== -1) {
                favoriteVehicles.splice(indexVehicle, 1);
            }
        }

        Cookies.set('favorite_vehicles', favoriteVehicles);

        $( document ).trigger("favorite-list-updated");
    }

    var getFavoriteVehicleList = function () {
        var favoriteVehicles = Cookies.getJSON('favorite_vehicles');

        if (favoriteVehicles == undefined) {
            favoriteVehicles = [];
        }

        return favoriteVehicles;
    }

    var refreshVehicleButtonState = function(buttonElem) {
        var vehicleId = $(buttonElem).attr('data-favorite-vehicle');
        var favoriteVehicles = getFavoriteVehicleList();

        if (favoriteVehicles.indexOf(vehicleId) === -1) {
            $(buttonElem).removeClass('selected');
            $(buttonElem).find('i').removeClass('icon-heart-full');
        } else {
            $(buttonElem).addClass('selected');
            $(buttonElem).find('i').addClass('icon-heart-full');
        }
    }

    global.initFavoriteButtons = initFavoriteButtons;
}


// WEBPACK FOOTER //
// ./app/Resources/assets/default/js/vehicle/favorite.js